import { Translate } from '@chipinside/translate'
import { useEffect } from 'react'

import { FallbackMessage, FallbackTitle, FallbackWrapper } from '#/pages/Fallback/Styles'
import { useUserInfo } from '#/store/ducks/auth'
import { Sentry } from '#/store/services/Sentry'

export function Error403() {
  const user = useUserInfo() as any
  const { href } = window?.location ?? {}

  useEffect(() => {
    Sentry.captureException(new Error(`403 - Forbidden page opened: ${href}`), {
      extra: {
        url: href,
      },
      fingerprint: [href],
      level: 'error',
      tags: {
        code: '403',
      },
      user: {
        email: user?.email,
        username: user?.name,
      },
    })
  }, [])

  return (
    <FallbackWrapper code={403}>
      <FallbackTitle>{Translate({ messageKey: '403_fallback_title' })}</FallbackTitle>
      <FallbackMessage>{Translate({ messageKey: '403_fallback_message' })}</FallbackMessage>
    </FallbackWrapper>
  )
}
